import React, { useEffect, useState } from 'react';

import { Typography } from '@mui/material';
import { getBuildInfo } from 'app/services/deviceTelemetry/deviceTelemetry.utils';
import PropTypes from 'prop-types';

import { getIsMobileLayoutForced, getIsNativePlatform } from 'utils/platform';

import { APP_VERSION_INLINE_DEFAULT_COLOR } from './AppVersionInline.constants';

const AppVersionInline = ({ color = APP_VERSION_INLINE_DEFAULT_COLOR }) => {
  const [buildInfo, setBuildInfo] = useState(null);

  useEffect(() => {
    getBuildInfo()
      .then(setBuildInfo)
      .catch(() => null);
  }, []);

  if (!buildInfo) {
    return null;
  }

  const isNative = getIsNativePlatform() || getIsMobileLayoutForced();

  if (isNative) {
    return (
      <Typography color={color} variant="regular12">
        OTA v{buildInfo.bundleVersion} · build {buildInfo.versionBuild} · {buildInfo.channel}
      </Typography>
    );
  }

  const webBuild = buildInfo.versionBuild || buildInfo.appNativeVersion;

  if (!webBuild) {
    return null;
  }

  return (
    <Typography color={color} variant="regular12">
      Build {webBuild}
    </Typography>
  );
};

AppVersionInline.propTypes = {
  color: PropTypes.string,
};

export default AppVersionInline;
